package com.devi3east.bashbuddy.account.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.devi3east.bashbuddy.account.organization.domain.models.Organization
import com.devi3east.bashbuddy.auth.ui.components.OrganizationPicker

@Composable
fun SelectOrganizationPromotionCard(
    organizations: List<Organization>,
    onSubmit: (Organization) -> Unit,
    modifier: Modifier = Modifier,
    shape: RoundedCornerShape = RoundedCornerShape(16.dp)
) {
    var selectedOrg by remember { mutableStateOf<Organization?>(null) }
    var submitted by remember { mutableStateOf(false) }

    if (submitted) return

    ElevatedCard(
        modifier = modifier
            .fillMaxWidth()
            .clip(shape)
            .border(
                border = BorderStroke(2.dp, MaterialTheme.colorScheme.primary),
                shape = shape
            ),
        shape = shape,
        colors = CardDefaults.elevatedCardColors(
            containerColor = MaterialTheme.colorScheme.onPrimary
        ),
        elevation = CardDefaults.elevatedCardElevation(6.dp)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                text = "Support An Organization",
                style = MaterialTheme.typography.titleMedium,
                fontWeight = FontWeight.Bold,
                color = MaterialTheme.colorScheme.primary
            )
            Text(
                text = "Select an organization from the list below to cast your vote in the promotional contest.",
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurface,
                modifier = Modifier
                    .fillMaxWidth(),
                textAlign = TextAlign.Center
            )
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                OrganizationPicker(
                    organizations = organizations,
                    selectedOrganization = selectedOrg,
                    label = "Organization",
                    onSelected = { selectedOrg = it },
                    modifier = Modifier.weight(1f)
                )
                Button(
                    onClick = {
                        selectedOrg?.let {
                            submitted = true
                            onSubmit(it)
                        }
                    },
                    enabled = selectedOrg != null,
                    shape = RoundedCornerShape(12.dp),
                    colors = ButtonDefaults.buttonColors(
                        containerColor = MaterialTheme.colorScheme.primary,
                        contentColor = MaterialTheme.colorScheme.onPrimary
                    )
                ) {
                    Text(
                        text = "Submit",
                        fontWeight = FontWeight.SemiBold
                    )
                }
            }
        }
    }
}